// On-spot group registration: one shared form, one registration per name.

export const MAX_GROUP_SIZE = 200;

const NOT_A_PERSON = /(father|mother|husband|guardian|spouse|organi[sz]ation|company|institut|hospital|college|school|firm|business|event|file|user)/i;

/** The form field that holds the attendee's name: an exact "Name" first, else the first text field mentioning a name. */
export function findNameField(schema = []) {
  const texts = (schema || []).filter((f) => f && (!f.type || f.type === 'text') && f.label);
  return texts.find((f) => f.label.trim().toLowerCase() === 'name')
    || texts.find((f) => /full\s*name/i.test(f.label))
    || texts.find((f) => /name/i.test(f.label) && !NOT_A_PERSON.test(f.label))
    || null;
}

/** Splits pasted text into names: one per line, or comma/semicolon separated. */
export function parseNames(text) {
  return String(text || '')
    .split(/\r?\n|[;,]/)
    .map((name) => name.replace(/\s+/g, ' ').trim())
    .filter(Boolean);
}

/** Resizes the list of extra names (people 2..N), keeping what was typed. */
export function resizeNames(names, groupSize) {
  const wanted = Math.max(0, Math.min(MAX_GROUP_SIZE, groupSize) - 1);
  const next = names.slice(0, wanted);
  while (next.length < wanted) next.push('');
  return next;
}
